<template>
  <d2-container>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      highlight-current-row
      style=" margin-top: 20px"
      :data="userList"
    >
      <el-table-column align="center" label="id">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="名称">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="icon">
        <template slot-scope="scope">
          <span>
            <img :src="scope.row.icon" class="img" />
          </span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="类型">
        <template slot-scope="scope">
          <span v-if="scope.row.type == 1">系统消息</span>
          <span v-if="scope.row.type == 2">订单消息</span>
          <span v-if="scope.row.type == 3">任务消息</span>
          <span v-if="scope.row.type == 4">客服</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="更新时间">
        <template slot-scope="scope">
          <span>{{ scope.row.updateTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right" width="200">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            @click="getEdit(scope.row)"
            v-permission:function="['newsListManasger:btn_edit']"
            style="margin-top:10px"
          >修改</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="修改" :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="rules" ref="form" label-width="140px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item
          label="图标"
          prop="icon2"
          :rules="[
        { required: true, message: '请上传图标', trigger: 'change' },]"
        >
          <uploadImg
            v-model="form.icon"
            :max="1"
            :text="['图片大小500kb以内', '图片格式png/jpg/gif','图片宽度101px,高度101px']"
          ></uploadImg>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('form')">取 消</el-button>
        <el-button type="primary" @click="getAdopt('form')">确 定</el-button>
      </div>
    </el-dialog>
  </d2-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { getUserList, getUserUpdate } from '@/api/demo/news/index'
import uploadImg from '@/components/uploadImage/index.vue'
export default {
  name: 'newsListManasger',
  computed: {
    ...mapGetters(['elements'])
  },
  components: {
    uploadImg
  },
  data () {
    return {
      tableKey: 0,
      userList: [],
      newsListManasger_btn_edit: false,
      dialogFormVisible: false,
      form: {
        id: '',
        name: '',
        icon: '',
        icon2: []
      },
      rules: {
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 30,
            message: '长度在 1 到 50 个字符',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    this.getUsers()
  },
  mounted () {},
  methods: {
    getUsers () {
      let that = this
      getUserList().then(res => {
        that.userList = res
        console.log('that.userList', that.userList)
      })
    },
    // 修改
    getEdit (row) {
      this.form.name = row.name
      this.form.id = row.id
      this.dialogFormVisible = true
    },
    // 取消
    cancel () {
      this.dialogFormVisible = false
    },
    getAdopt (forms) {
      let that = this
      this.$refs[forms].validate(valid => {
        if (valid) {
          getUserUpdate(that.form.id, that.form).then(res => {
            that.getUsers()
            that.$message({
              message: '修改成功',
              type: 'success',
              center: true
            })
            that.dialogFormVisible = false
          })
        }
      })
    }
  }
}
</script>
<style scope>
.img {
  width: 60px;
  height: 60px;
}
</style>
